import { Box, Card, CardActions, CardContent, Grid } from '@mui/material';
import { AppImageDimension } from 'app/appImages';
import { MprcCardRibbonData } from 'components/MprcRibbonList';
import React from 'react';

interface IProps {
    items: MprcCardRibbonData[];
    marginWidth?: number;
}

const RenderCardMedia = ({ thumbnail, thumbStickerLeft, thumbStickerRight }: MprcCardRibbonData) => {
    return thumbStickerLeft || thumbStickerRight
        ? <Box sx={{ position: "relative" }}>
            {thumbnail}
            <Box sx={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
                <Grid container justifyContent="center" width="100%">
                    <Grid size={{ xs: 6 }}>{thumbStickerLeft ?? ""}</Grid>
                    <Grid size={{ xs: 6 }}>{thumbStickerRight ?? ""}</Grid>
                </Grid>
            </Box>
        </Box>
        : <>{thumbnail}</>;
};

export function BuildRibbonCards({ items, marginWidth = 0 }: IProps): React.ReactNode[] {
    return items.map((item, index) => (
        <Card
            key={index}
            sx={
                {
                    minWidth: AppImageDimension.ThumbnailLg.width,
                    maxWidth: AppImageDimension.ThumbnailLg.width,
                    mr: `${marginWidth}px`,
                    ml: `${marginWidth}px`
                }
            }
            elevation={1}
        >
            <RenderCardMedia {...item} />
            <CardContent sx={{ p: 1 }}>
                {item.body}
            </CardContent>
            <CardActions disableSpacing sx={{ p: 0, pl: 1, pr: 1 }}>
                {item.actions}
            </CardActions>
        </Card>
    ));
}
